import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type DashboardLayoutTemplateViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  forRoleValue?: { displayId: string; id: string } | null;
  forRole: string;
  widgetsValue?: { displayId: string; id: string } | null;
  widgets: string;
  isDefaultValue?: { displayId: string; id: string } | null;
  isDefault: boolean;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
  isForAllTenantsValue?: { displayId: string; id: string } | null;
  isForAllTenants: boolean;
};

export const DashboardLayoutTemplateViewForm: React.FC<DashboardLayoutTemplateViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      forRole = "",
      widgets = "{}",
      isDefault = false,
      enabled = false,
      isForAllTenants = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupDashboardLayoutTemplateLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.DashboardLayoutTemplateNameLabel}
                />
                <ShowMultiLine
                  value={forRole}
                  label={langStore.DashboardLayoutTemplateForRoleLabel}
                />
                <InputCodeEditor
                  value={widgets}
                  onChange={() => {}}
                  label={langStore.DashboardLayoutTemplateWidgetsLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowBoolean
                  value={isDefault}
                  label={langStore.DashboardLayoutTemplateIsDefaultLabel}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.DashboardLayoutTemplateEnabledLabel}
                />
                <ShowBoolean
                  value={isForAllTenants}
                  label={langStore.DashboardLayoutTemplateIsForAllTenantsLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
